import React, { Fragment, useEffect, useRef, useState } from "react";
import { getApi } from "../../services/api/globalApi";
import Pagination from "./../../components/common/pagination/Pagination";
import { useNavigate } from "react-router";
import { motion } from "framer-motion";
import Loadning from "./../../components/common/loading/Loading.jsx";
import { FaUsers } from "react-icons/fa";

const PermissionList = () => {
  const [data, setData] = useState([]);
  const [pagination, setPagination] = useState();
  const [showLoading, setShowLoading] = useState(false);

  const getPermissions = async (params) => {
    setData([]);
    setShowLoading(true);
    const path = "admin/permissions";
    try {
      const response = await getApi({ path, params: { ...params } });
      console.log(response?.data);
      setPagination(response?.data.result);
      setData(response?.data.data.result.docs);
      setShowLoading(false);
    } catch (error) {
      console.log(error);
      setShowLoading(false);
    }
  };

  useEffect(() => {
    getPermissions({});
  }, []);


  const [filter, setFilter] = useState();

  const filterDataHandler = (newParams) => {
    setFilter({ ...filter, ...newParams });
    const allFilter = {
      ...filter,
      ...newParams,
    };
    console.log("filter", allFilter);
    getPermissions(allFilter);
  };

  const navigate = useNavigate();

  const editPermission = (item) => {
    navigate(`/permission/${item._id}`, { state: item });
  };


  return (
    <Fragment>
      {showLoading && <Loadning />}

      <motion.div
        initial={{ opacity: 0, scale: 0.5 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{
          duration: 0.5,
          // ease: [0, 0.71, 0.2, 1.01]
        }}
        className="w-11/12 mx-auto rounded-lg my-6 bg-white/50 backdrop-blur-sm dark:bg-[#060d26]/50 shadow-lg p-6"
      >
        <h6 className="mb-6 mt-2 text-gray-800 dark:text-white flex gap-x-2 items-center">
          <FaUsers size={26} />
          لیست دسترسی ها
        </h6>

        {data?.length > 0 ? (
          <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
            <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
              <thead className="text-xs text-gray-700 uppercase bg-gray-200 dark:bg-gray-700 dark:text-gray-400">
                <tr>
                  <th scope="col" className="px-6 py-3">
                    نام
                  </th>
                  <th scope="col" className="px-6 py-3">
                    <span className="sr-only">ویرایش</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                {data
                  ? data?.map((item, index) => {
                      return (
                        <tr
                          key={index}
                          className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600"
                        >
                          <th
                            scope="row"
                            className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white"
                          >
                            {item.name || "-"}
                          </th>
                          <td className="px-6 py-4 text-right flex">
                            <p
                              onClick={() => editPermission(item)}
                              className="font-medium cursor-pointer text-blue-600 mx-3 dark:text-blue-500 hover:underline"
                            >
                              ویرایش
                            </p>
                          </td>
                        </tr>
                      );
                    })
                  : null}
              </tbody>
            </table>
          </div>
        ) : (
          <p className="w-full py-2 flex justify-center items-center text-gray-800 dark:text-white">
            شما هنوز هیچ کاربری ثبت نکرده اید
          </p>
        )}
        <div className="mt-6">
          <Pagination
            pagination={pagination}
            filterDataHandler={filterDataHandler}
          />
        </div>
      </motion.div>
    </Fragment>
  );
};

export default PermissionList;
